import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { X } from 'lucide-react';
import './ContactPage.scss';
import { useSnackbar } from '../../contexts/SnackbarContext';
import { publicRequest } from '../../requestMethods';
import MosqueLoader from '../../utils/MosqueLoader';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer';
const ContactPage = () => {
    const navigate = useNavigate();
    const snackbar = useSnackbar();
    const [formData, setFormData] = useState({
        name: '',
        mobile: '',
        subject: '',
        content: ''
    });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const combinedContent = `Mobile: ${formData.mobile}\n\nMessage:\n${formData.content}\n\nName: ${formData.name}`;

        try {
            const response = await publicRequest.post("/utils/contact", {
                
                subject: formData.subject,
                content: combinedContent
            });
            console.log(response);
            snackbar.success('Thank you! We will get back to you soon.');
            setFormData({
                name: '',
                mobile: '',
                subject: '',
                content: ''
            });

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="contact-page">
            <Navbar />
            {loading && <MosqueLoader />}
            <div className="contact-page__overlay">
                <div className="contact-page__container">
                    <button 
                        className="contact-page__close-btn" 
                        onClick={() => navigate(-1)}
                        aria-label="Close"
                    >
                        <X size={24} />
                    </button>
                    <h1 className="contact-page__title">Contact Us</h1>
                    <form className="contact-form" onSubmit={handleSubmit}>
                    <div className="contact-form__group">
                        <label htmlFor="name">Name</label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            placeholder="Enter your name"
                        />
                    </div>
                    <div className="contact-form__group">
                        <label htmlFor="mobile">Mobile</label>
                        <input
                            type="text"
                            id="mobile"
                            name="mobile"
                            value={formData.mobile}
                            onChange={handleChange}
                            required
                            placeholder="Enter your mobile number"
                        />
                    </div>

                    <div className="contact-form__group">
                        <label htmlFor="subject">Subject</label>
                        <input
                            type="text"
                            id="subject"
                            name="subject"
                            value={formData.subject}
                            onChange={handleChange}
                            required
                            placeholder="Enter subject"
                        />
                    </div>

                    <div className="contact-form__group">
                        <label htmlFor="content">Content</label>
                        <textarea
                            id="content"
                            name="content"
                            value={formData.content}
                            onChange={handleChange}
                            required
                            placeholder="Enter your message"
                            rows="6"
                        />
                    </div>

                    <button type="submit" className="contact-form__submit" disabled={loading}>
                        {loading ? 'Sending…' : 'Send Message'}
                    </button>
                    </form>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default ContactPage;